import React from 'react'

export const BloxCertificate = [
  {
    name: 'Certificado',
    component: React.lazy(() => import('../../common/components/ConclusionCertificate')),
    path: '/student/validate_certificate/:bloxEnrollmentId',
    guards: [],
  },
]
